import React, { useState } from 'react';
import { Box, IconButton, Typography, Divider } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import CloseIcon from '@mui/icons-material/Close';
import TableModal from './ToolbarModel.tsx';
import FormDetailsModal from '../FormDetailsModal.tsx';
import ConfirmBox from '../../FlowBuilder/Common/ConfirmBox/index.tsx';
import { ConstantActions, LeadFormActions } from '../../../Services/_actions/index.js';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import AssignLeadsModal from '../AssignLeadsModal.tsx';
import StatusSubStatusModal from './StatusSubStatusModal.tsx';
import MoveToModal from './MoveToModal.tsx';
import { globalpermissions } from '../../../Services/Permission.js';

interface ToolBarProps {
  selectedLeadIds: string[];
  selectedCount: number;
  onClear: () => void;

  selectedRow: any;
  dynamicFormFields: any[];
  dynamicFormGroups: any[];
  currentCampaignId: string;
  currentLeadFormId: string;
  typeOfStatusList: any;
  parentLead: any;
}


const ToolBar: React.FC<ToolBarProps> = ({
  selectedCount,
  onClear,
  selectedLeadIds,

  selectedRow,
  dynamicFormFields,
  dynamicFormGroups,
  currentCampaignId,
  currentLeadFormId,
  typeOfStatusList,
  parentLead
}) => {
  const [openFormDetailModal, setOpenFormDetailModal] = useState(false);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const leadActions = LeadFormActions();
  const { showSnackBar } = useSnackBar();
  // const [isLeadAssignModalOpen, setIsLeadAssignModalOpen] = useState(false);
  // const [isUnassignModalOpen, setIsUnassignModalOpen] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [openMoveToModal, setOpenMoveToModal] = useState(false);
  const constantActions = ConstantActions();


  const onCloseFormFieldsModal = (dynamicFormData, type = '') => {
    setOpenFormDetailModal(false);
  };


  if (!selectedCount) return null;

  const handleMoveTo = () => {
    setOpenMoveToModal(true);
    console.log("Move To clicked");
  };

  // const handleUpdate = () => {
  //   setOpenFormDetailModal(true);
  // };

  // const handleAssignUnassign = () => {
  //   if (selectedCount > 1 || !selectedRow?.assigned_to_user) {
  //     setIsLeadAssignModalOpen(true);
  //   } else {
  //     setIsUnassignModalOpen(true);
  //   }
  // };

  // const handleAssignModalClose = () => {
  //   setIsLeadAssignModalOpen(false);
  //   onClear();
  // };

  // const handleUnassignModalClose = () => {
  //   setIsUnassignModalOpen(false);
  //   onClear();
  // };

  const handleStatusSubstatus = () => {
    setOpenStatusModal(true);
  };


  const confirmDeleteLead = async (confirmed: boolean) => {
    if (confirmed && selectedRow) {
      try {
        const leadIds = Array.isArray(selectedRow)
          ? selectedRow.map((row) => row.lead_id)
          : [selectedRow.lead_id];

        const payload = {
          lead_ids: leadIds,
        };
        const res: any = await leadActions.deleteLeadV1(payload);
        if (res?.status === 200) {
          showSnackBar('Record deleted successfully!', 'success');
          onClear();
        } else {
          showSnackBar('Failed to delete record.', 'error');
        }
      } catch (error) {
        showSnackBar('Failed to delete record.', 'error');
      } finally {
        // setSelectedRow(null);
      }
    }
  };

  // const isSingleSelected = selectedCount === 1;
  // const isAssigned = isSingleSelected && selectedRow?.assigned_to_user;
  // const assignLabel = isAssigned ? "Unassign" : "Assign";

  const ActionButton = ({ icon, label, onClick }) => (
    <Box
      onClick={onClick}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        px: 1.5,
        py: 1,
        cursor: 'pointer',
        borderRadius: 1,
        transition: '0.2s',
        '&:hover': { backgroundColor: 'grey.50' }
      }}
    >
      {icon}
      <Typography variant="caption" sx={{ mt: 0.5 }}>{label}</Typography>
    </Box>
  );

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 155,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1300,
      }}
    >
      <Box
        sx={{
          backgroundColor: 'white',
          borderRadius: 4,
          border: '1px solid',
          borderColor: 'grey.200',
          boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          px: 1.5,
          py: 1,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pr: 2 }}>
          <Box
            sx={{
              width: 28,
              height: 28,
              backgroundColor: 'primary.main',
              color: 'white',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '0.75rem',
              fontWeight: 600,
            }}
          >
            {selectedCount}
          </Box>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {selectedCount} Records selected
          </Typography>
        </Box>

        <Divider orientation="vertical" flexItem />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <ActionButton
            icon={<DriveFileMoveIcon fontSize="small" />}
            label="Move To"
            onClick={handleMoveTo}
          />
          {/* <ActionButton
            icon={<EditIcon fontSize="small" />}
            label="Update"
            onClick={handleUpdate}
          /> */}
          <ActionButton
            icon={<EditIcon fontSize="small" />}
            label="Update"
            onClick={handleStatusSubstatus}
          />
          {/* <ActionButton
            icon={<AssignmentIndIcon fontSize="small" />}
            label={assignLabel}
            onClick={handleAssignUnassign}
          /> */}
          {constantActions.userHasPermission([
            globalpermissions?.leadDashboard?.deleteLeadColumn,
          ]) && (
              <ActionButton
                icon={<DeleteIcon fontSize="small" />}
                label="Delete"
                // onClick={handleDelete}
                onClick={() => {
                  setConfirmDeleteOpen(true);
                }}
              />
            )}
        </Box>

        <Divider orientation="vertical" flexItem />

        <IconButton onClick={onClear} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      {/* {openFormDetailModal && (
        <FormDetailsModal
          open={openFormDetailModal}
          onClose={(data, type) => onCloseFormFieldsModal(data, type)}
          multipleFormUpdate={true}
          selectedRow={selectedRow}
          dynamicFormFields={dynamicFormFields}
          dynamicFormGroups={dynamicFormGroups}
          currentCampaignId={currentCampaignId}
          currentLeadFormId={currentLeadFormId}
          parentLead={parentLead}
        />

      )} */}
      <ConfirmBox
        open={confirmDeleteOpen}
        onClose={(confirmed) => {
          confirmDeleteLead(confirmed);
          setConfirmDeleteOpen(false);
        }}
        options={{
          title: 'Delete Record',
          text: 'Are you sure you want to delete this record?',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          confirmButtonColor: 'error',
          cancelButtonColor: 'default',
        }}
      />
      {/* <AssignLeadsModal
        open={isLeadAssignModalOpen}
        onClose={handleAssignModalClose}
        selectedLeads={selectedLeadIds}
        selectedRow={isSingleSelected ? selectedRow : null}
        campaignId={currentCampaignId}
      />

      <AssignLeadsModal
        open={isUnassignModalOpen}
        onClose={handleUnassignModalClose}
        selectedLeads={null}
        selectedRow={selectedRow}
        campaignId={currentCampaignId}
      /> */}
      <StatusSubStatusModal
        open={openStatusModal}
        onClose={() => setOpenStatusModal(false)}
        campaignId={currentCampaignId}
        dynamicFormFields={dynamicFormFields}
        typeOfStatusList={typeOfStatusList}
        selectedLeadIds={selectedLeadIds}
        selectedRow={selectedRow}
        onSuccess={() => {
          onClear();
        }}
      />
      <MoveToModal
        open={openMoveToModal}
        onClose={() => {
          setOpenMoveToModal(false);
          onClear();
        }}
        selectedLeadIds={selectedLeadIds}
        selectedRow={selectedRow}
        campaignId={currentCampaignId}
      />
    </Box>
  );
};

export default ToolBar;
